const state = {
    policy_no: localStorage.getItem('policy_no') || ''
}
const mutations = {
    SET_POLICY_NO: (state, policy_no) => {
        state.policy_no = policy_no
    }
}
const actions = {
    setPolicy_no({
        commit
    }, result) {
        commit("SET_POLICY_NO", result || policy_no)
        localStorage.setItem('policy_no', result)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}